import React from 'react';
import PropTypes from 'prop-types';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';

const SearchBar = ({ searchText, handleSearch }) => {
  return (
    <div className="users-search">
      <img src={MagnifyingGlass} alt="Search" />
      <input
        id="users-search-input"
        type="text"
        placeholder="Search..."
        value={searchText}
        onChange={handleSearch}
      />
    </div>
  );
};

SearchBar.propTypes = {
  searchText: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
};

export default SearchBar;
